/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_NoneInputs */

const vi_warehouse_position_none = /** @type {(inputs: Warehouse_Position_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa gán vị trí`)
};

/**

* @param {Warehouse_Position_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_none = /** @type {((inputs?: Warehouse_Position_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_none(inputs)
});